<template>
    <div class="form-check">
        <input
            :id="id"
            v-indeterminate="isIndeterminate"
            type="checkbox"
            class="form-check-input"
            :checked="modelValue"
            :disabled="isDisabled"
            :required="isRequired"
            :aria-required="isRequired ? 'true' : undefined"
            @change="onChange"
        >
        <label
            v-safe-html="isListItem ? '' : label"
            :aria-label="ariaLabel"
            class="form-check-label"
            :for="id"
        />
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: "CheckBox",
    directives: {
        indeterminate(el: HTMLInputElement, binding) {
            el.indeterminate = Boolean(binding.value);
        }
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true
        },
        id: {
            type: String,
            default: undefined
        },
        label: {
            type: String,
            default: undefined
        },
        ariaLabel: {
            type: String,
            default: undefined
        },
        isListItem: {
            type: Boolean,
            default: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        isIndeterminate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isCheckedData: {
            get() {
                return this.modelValue !== undefined ? this.modelValue : this.isChecked;
            },
            set(newCheckedValue: boolean) {
                this.$emit("change", newCheckedValue);
            }
        }
    },
    methods: {
        onChange(event: Event) {
            const target = event.target as HTMLInputElement;
            this.isCheckedData = target.checked;
        }
    }
});
</script>

<style scoped>
</style>
